import { getFirebase } from '../../firebase';

export const changePassword = (
  code: string,
  password: string
): ((dispatch: any) => Promise<void>) => async _ => {
  return getFirebase().auth().confirmPasswordReset(code, password);
};
